__turbopack_context__.v({
  "description": "index-module-scss-module__nZxkpq__description",
  "item": "index-module-scss-module__nZxkpq__item",
  "label": "index-module-scss-module__nZxkpq__label",
  "link": "index-module-scss-module__nZxkpq__link",
  "list": "index-module-scss-module__nZxkpq__list",
});
